module.exports = __webpack_public_path__ + "img/slack.8515dc28.svg";